import { useSearchParams } from 'react-router-dom';
import { SEARCH_PARAMS, SORT_DIRECTION_INDICATOR } from 'constants/dataSets';
import { ORDER_KEY, ORDER_TYPE, SORT } from 'constants/formFields';
import { ORDERS, type TOrderByIdentifier } from 'constants/interfaces';
import useDebouncedCallback from 'hooks/useDebouncedCallback';

import type { ISearchInputHandler } from 'components/TextField/interfaces/ITextField';
import type IUseDataTaskListActions from '../interfaces/IUseDataTaskListActions';

const useDataTaskListActions = (
  {
    setOrderBy,
    getValues,
    setValue,
  }: IUseDataTaskListActions,
) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const onSortChange = (orderByIdentifier: TOrderByIdentifier) => {
    const { sort: { orderKey, orderType } } = getValues();
    const isAsc = orderKey === orderByIdentifier && orderType === ORDERS.asc;
    setValue(SORT, { [ORDER_KEY]: orderByIdentifier, [ORDER_TYPE]: isAsc ? ORDERS.desc : ORDERS.asc });
    const order = isAsc ? `${SORT_DIRECTION_INDICATOR}${orderByIdentifier}` : orderByIdentifier;
    setOrderBy(order);
  };

  const debouncedSearch = useDebouncedCallback(() => {
    const { search } = getValues();
    const newSearchParams = {
      ...Object.fromEntries(searchParams),
      [SEARCH_PARAMS.search]: search || '',
      [SEARCH_PARAMS.offset]: '0',
    };
    setSearchParams(newSearchParams, { replace: true });
  });

  const onSearchChange = ({ search, onChange }: ISearchInputHandler) => {
    onChange(search);
    debouncedSearch();
  };

  return {
    onSortChange,
    onSearchChange,
  };
};

export default useDataTaskListActions;
